import React, { Fragment } from 'react';
import {
    Select,
    SelectTrigger,
    SelectValue,
    SelectContent
} from './select';
import { MenuItem } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { Checkbox } from './checkbox';
import { Chip } from '@mui/material';
import { IoClose } from 'react-icons/io5';

const MultiSelectInput = ({ onValueChange, value = [], options = [], rules, errors, placeholder, className, name = '', control, label, required, defaultValue = [], disabled }) => {

    const handleCheckboxChange = (event, selectedValue) => {
        event.preventDefault();
        const newValue = value.includes(selectedValue)
            ? value.filter(val => val !== selectedValue)
            : [...value, selectedValue];
        onValueChange(newValue, name);
    };

    const handleMenuItemClick = (event, itemValue) => {
        event.stopPropagation();
        handleCheckboxChange(event, itemValue);
    };

    const handleRemoveItem = (itemValue) => {
        const newValue = value.filter(val => val !== itemValue);
        onValueChange(newValue, name);
    };

    const renderSelectedItems = (selected) => {
        return (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px' }}>
                {selected.map((selectedValue, index) => {
                    const selectedItem = options.find(option => option.value === selectedValue);
                    return selectedItem ? (
                        <Chip
                            sx={{ height: '30%', borderRadius: '3px', backgroundColor: 'hsl(var(--primary-foreground))', color: 'hsl(var(--primary))' }}
                            key={index}
                            label={selectedItem.label}
                            // onDelete={() =>  isCloseIcon && handleRemoveItem(selectedValue)}
                            // deleteIcon={ <IoClose color='hsl(var(--destructive))' size={15} />}
                            onMouseDown={(event) => event.stopPropagation()}
                        />
                    ) : null;
                })}
            </div>
        );
    };

    return (
        <Fragment>
            {label && <label className='grc-label block mb-1'>{label}{required && <span className='text-danger'>*</span>}</label>}
            <Controller
                defaultValue={defaultValue}
                name={name}
                control={control}
                rules={rules}
                render={({ field: { onChange } }) => (
                    <Select
                        key={name}
                        onValueChange={e => { onValueChange(e, name); onChange(e); }}
                        value={value}
                        defaultValue={defaultValue}
                        disabled={disabled}
                        multiple
                    >
                        <SelectTrigger className={'input-grc select-trigger ' + className}>
                            <SelectValue placeholder={placeholder}>
                            {value?.length > 0 ? renderSelectedItems(value) : <span style={{ color: 'hsl(var(--border))' }}>{placeholder}</span>}
                            </SelectValue>
                        </SelectTrigger>
                        <SelectContent className='bg-card'>
                            {options?.map((item, index) => {
                                return (
                                    <MenuItem
                                        value={item.value}
                                        key={index}
                                        // style={{ borderBottom: '1px solid hsl(var(--border))' }}
                                        onClick={(event) => handleMenuItemClick(event, item?.value)}
                                    >
                                        <Checkbox
                                            checked={value?.includes(item?.value)}
                                            onChange={(event) => handleCheckboxChange(event, item?.value)}
                                            className="mr-2"
                                        />
                                        {item.label}
                                    </MenuItem>
                                )
                            })}
                        </SelectContent>
                    </Select>
                )}
            />
            <p className='grc-error-msg text-danger'>{errors && name && errors[name]?.message}</p>
        </Fragment>
    );
};

MultiSelectInput.propTypes = {
    className: PropTypes.string,
    value: PropTypes.array,
    onValueChange: PropTypes.func,
    name: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    errors: PropTypes.any,
    rules: PropTypes.object,
    control: PropTypes.any,
    message: PropTypes.any,
    required: PropTypes.bool,
    options: PropTypes.array,
    defaultValue: PropTypes.array
};

export default MultiSelectInput;
